<!-- W8ben.vue -->
<template>
  <div class="w8ben-container">
    <Progress progress="70"></Progress>
    <div class="card-wrapper">
      <!-- 纳税人姓名卡片 -->
      <div class="ipt-box" :class="{error:  showError && !formData.tax_name, focus: inputFocusId == 1, disabledBg: pageChange != 1}">
        <div class="ipt-main">
          <div class="val-box">
            <span class="label" v-if="inputFocusId == 1 || formData.tax_name">{{ $t('w8benPage.taxPayerName') }}（{{ $t('w8benPage.w000006') }}）</span>
            <van-field
              class="val"
              :disabled="pageChange != 1"
              v-model="formData.tax_name"
              :placeholder="inputFocusId == 1 ? '' : `${$t('w8benPage.taxPayerName')}（ ${$t('w8benPage.w000006')}）`"
              :formatter="formatVal"
              @focus="inputFocus(1)"
              @blur="inputBlur"
            ></van-field>
          </div>
        </div>
        <p class="error">{{ $t('w8benPage.taxPayerName') }}{{ $t('w8benPage.w000007') }}</p>
      </div>

      <!-- 所属地区卡片 -->
      <div class="ipt-box" :class="{error: !formData.contain_area && showError, disabledBg: pageChange != 1, focus: inputFocusId == 2}">
        <div class="ipt-main">
          <div class="val-box" @click="checkCountryDialog">
            <span class="label" v-if="inputFocusId == 2 || formData.contain_area">{{ $t('w8benPage.associatedArea') }}（{{ $t('w8benPage.w000006') }}）</span>
            <van-field
              class="val"
              :disabled="pageChange != 1"
              :readonly="true"
              v-model="formData.contain_area"
              :placeholder="inputFocusId == 2 ? '' : `${$t('w8benPage.associatedArea')}（ ${$t('w8benPage.w000006')}）`"
              :formatter="formatVal"
              @focus="inputFocus(2)"
              @blur="inputBlur"
            ></van-field>
          </div>
        </div>
        <p class="error">{{ $t('w8benPage.associatedArea') }}{{ $t('w8benPage.w000007') }}</p>
      </div>

      <div class="box" v-if="stepOneInfo.process_id == 1">
        <div class="title">{{ $t('m000038') }}</div>
        <div class="ipt-box" :class="{error: !formData.identity_province_code && showError, disabledBg: true }">
          <!-- @click="showAddressPopup" -->
          <div class="ipt-main" >
            <div class="val-box">
            <span class="label" :class="{ placeholder: !formData.identity_province_code }"
            >{{ $t('w8benPage.addressOwnership') }}（{{ $t('w8benPage.w000006') }}）</span
            >
              <span class="val" v-if="formData.identity_province_code">{{ getIdentityFullAddress() || $t('w8benPage.belongingTip') }}</span>
            </div>
            <span class="icon-arrow"></span>
          </div>
          <p class="error">{{ $t('w8benPage.addressOwnership') }}{{ $t('w8benPage.w000007') }}</p>
        </div>
        <!-- 详细地址卡片 -->
        <div class="ipt-box" :class="{error: showError && !formData.identity_detail_address, focus: inputFocusId == 4, disabledBg: true}">
          <div class="ipt-main">
            <div class="val-box">
              <span class="label">{{ $t('w8benPage.detailedAddress') }}（{{ $t('w8benPage.w000006') }}）</span>
              <van-field
                class="val"
                v-model="formData.identity_detail_address"
                type="textarea"
                :disabled="true"
                rows="2"
                :placeholder="inputFocusId == 4 ? '' : `${$t('w8benPage.detailedAddress')}（ ${$t('w8benPage.w000006')}）`"
                @focus="inputFocus(4)"
                @blur="inputBlur"
              ></van-field>
            </div>
          </div>
          <p class="error">{{ $t('w8benPage.detailedAddress') }}{{ $t('w8benPage.w000007') }}</p>
        </div>
      </div>

      <div class="box">
        <div class="title">{{ $t('m000039') }}</div>
        <div class="ipt-box" :class="{error: !formData.contain_area && showError, disabledBg: pageChange != 1, focus: inputFocusId == 2 }">
          <div class="ipt-main">
            <!-- @click="checkCountryDialog" -->
            <div class="val-box" >
              <span class="label" v-if="inputFocusId == 2 || formData.contain_area">{{ $t('w8benPage.associatedArea') }}（{{ $t('w8benPage.w000006') }}）</span>
              <van-field
                class="val"
                v-model="formData.nationality_or_region_name"
                :disabled="true"
              ></van-field>
            </div>
          </div>
          <p class="error">{{ $t('w8benPage.associatedArea') }}{{ $t('w8benPage.w000007') }}</p>
        </div>
        <!-- 地址归属卡片 -->
        <template v-if="[1,2, '1', '2'].includes(identityInf.nationality_or_region_code || identityInf.nationality_code)">
          <div class="ipt-box" :class="{error: !formData.province_code && showError, disabledBg: true }">
            <div class="ipt-main" >
              <!-- @click="showAddressPopup" -->
              <div class="val-box">
              <span class="label" :class="{ placeholder: !formData.province_code }"
              >{{ $t('w8benPage.addressOwnership') }}（{{ $t('w8benPage.w000006') }}）</span
              >
                <span class="val" v-if="formData.province_code">{{ getFullAddress() || $t('w8benPage.belongingTip') }}</span>
              </div>
              <span class="icon-arrow"></span>
            </div>
            <p class="error">{{ $t('w8benPage.addressOwnership') }}{{ $t('w8benPage.w000007') }}</p>
          </div>
        </template>
        <!-- 其它地区显示输入框 -->
        <template v-else>
          <div class="ipt-box" :class="{error: showError && !formData.otherAffiliation, focus: inputFocusId == 5, disabledBg: true }">
            <div class="ipt-main">
              <!-- @click="checkCountryDialog" -->
              <div class="val-box" >
                <span class="label" v-if="inputFocusId == 5 || formData.otherAffiliation">{{ $t('w8benPage.addressOwnership') }}（{{ $t('w8benPage.w000006') }}）</span>
                <van-field
                  class="val"
                  v-model="formData.otherAffiliation"
                  :placeholder="inputFocusId == 5 ? '' : `${$t('w8benPage.addressOwnership')}（ ${$t('w8benPage.w000006')}）`"
                  :formatter="formatVal"
                  :disabled="true"
                  @focus="inputFocus(5)"
                  @blur="inputBlur"
                ></van-field>
              </div>
            </div>
            <p class="error">{{ $t('w8benPage.addressOwnership') }}{{ $t('w8benPage.w000007') }}</p>
          </div>
        </template>

        <!-- 详细地址卡片 -->
        <div class="ipt-box" :class="{error: showError && !formData.detail_address, focus: inputFocusId == 4, disabledBg: true }">
          <div class="ipt-main">
            <div class="val-box">
              <span class="label">{{ $t('w8benPage.detailedAddress') }}（{{ $t('w8benPage.w000006') }}）</span>
              <van-field
                class="val"
                v-model="formData.detail_address"
                type="textarea"
                rows="2"
                :disabled="true"
                :placeholder="inputFocusId == 4 ? '' : `${$t('w8benPage.detailedAddress')}（ ${$t('w8benPage.w000006')}）`"
                @focus="inputFocus(4)"
                @blur="inputBlur"
              ></van-field>
            </div>
          </div>
          <p class="error">{{ $t('w8benPage.detailedAddress') }}{{ $t('w8benPage.w000007') }}</p>
        </div>
      </div>

    </div>

    <!-- 底部按钮 -->
    <nav-buttons
      navigationType="back"
      :next-text="$route.query.change == 1 ? $t('openAccount.t000094') : $t('openAccount.t000095')"
      @on-next="handleNext"
    />

    <!-- 地址归属弹出层 -->
    <van-popup
      v-model="showPopup"
      position="bottom"
      round
      safe-area-inset-bottom
      class="address-popup picker-ui"
    >
      <van-area
        :area-list="areaList"
        :value="formData.country_code || formData.city_code || formData.province_code"
        @cancel="showPopup = false"
        @confirm="onAddressTypeConfirm"
      />
    </van-popup>
    <!-- 选择国籍弹窗 -->
    <van-popup
      v-model="checkCountryNameDialog"
      :showConfirmButton="false"
      :class="bgColor == 'black-theme' ? 'darkOrLight' : 'check-country'"
      getContainer="body"
      position="right"
    >
      <div class="dialog-head">
        <a class="btn-back" @click="checkCountryNameDialog = false"></a>
        <p class="dialog-title">{{$t('openAccount.t000096')}}</p>
      </div>
      <div class="input-box">
        <van-field
          v-model="checkCountryKeyWord"
          left-icon="search"
          :placeholder="$t('openAccount.t000097')"
        ></van-field>
      </div>
      <div class="list">
        <div class="list-main">
          <template v-for="item in countryAddress">
            <div
              v-if="
                !checkCountryKeyWord ||
                  item.name.indexOf(checkCountryKeyWord) >= 0
              "
              @click="checkCountry(item)"
              class="item"

              :key="item.id"
            >
              <span>{{ item.name }}</span>
              <Icon
                v-show="formData.contain_area == item.name"
                name="success"
                color="#ff9275"
              />
            </div>
          </template>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Button, Field, Popup, Icon, Area, Toast } from "vant";
import navButtons from '../components/navButtons.vue'
import Progress from '../components/Progress.vue'
import pinyin from 'pinyin';

export default {
  name: "W8ben",

  components: {
    [Button.name]: Button,
    [Field.name]: Field,
    [Popup.name]: Popup,
    [Area.name]: Area,
    Icon,
    navButtons,
    Progress,
  },

  data() {
    this.countryAddress = [];
    return {
      inputFocusId: -1,
      formData: {
        tax_name: "",
        contain_area: "",
        province_name: "",
        province_code: "",
        city_code: "",
        city_name: "",
        country_name: "",
        country_code: "",
        detail_address: "",
        otherAffiliation: "",
        nationality_or_region_name: ""
      },
      identityInf: {},
      showPopup: false,
      areaList: {},
      showError: false,
      process_id: 1,    // 开户类型
      pageChange: 0,     // 开户错误修改标识
      checkCountryNameDialog: false,
      checkCountryKeyWord: "",  // 国籍搜索key
      stepOneInfo: {},
      identityConfig31: {}
    };
  },

  computed: {
    isFormValid() {
      // 'province_name', 'province_code',
      let key = ['tax_name', 'contain_area',  'detail_address'];
      if(this.process_id == 3){
        // , 'otherAffiliation'
        key = ['tax_name', 'contain_area', 'detail_address'];
      }
      
      
      let pass = true;
      for(let i = 0; i < key.length; i++){
        if(!this.formData[key[i]]){
          
          pass = false;
        }
      }
      return pass;
    },
    bgColor() {
      return this.$store.getters["common/bgColor"];
    }
  },

  created() {
    this.init();
  },

  methods: {
    init() {
      this.getRouteParams();
      this.fetchFormData();
    },
    async fetchFormData() {
      try {
        // 获取账户信息
        const response = await this.$apis.accountSituationV2({ step_code: '1,3-2,4,10,3-1' });
        // 获取第一步的process_id
        this.handleProcessId(response);
        // 获取国籍数据
        await this.getAreaList();
        // 获取省市区数据
        await this.getAddress();
        // 初始化配置数据
        const taxFormConfig = this.extractConfigData(response?.process_info?.[10]);
        const identityConfig = this.extractConfigData(response?.process_info?.['3-2']);
        const identityInfo = this.extractConfigData(response?.process_info?.[4]);
        const identityConfig31 = this.extractConfigData(response?.process_info?.['3-1']);
        const stepOneInfo = response?.process_info?.[1] || {};
        this.stepOneInfo = stepOneInfo;
        this.identityInf = identityInfo;
        
        // 更新表单数据
        await this.updateFormData(taxFormConfig, identityConfig, identityInfo, identityConfig31);
        

      } catch (error) {
        
      }
    },
    // 获取路由参数
    getRouteParams() {
      this.pageChange = this.$route.query.change || 0
    },
    handleProcessId(response) {
      this.process_id = response?.process_info?.[1]?.process_id || response?.get_open_account_info?.open_status;
    },
    // 返回解析后的数据对象
    extractConfigData(processInfo) {
      try {
        return JSON.parse(processInfo?.config_data || '{}');
      } catch (error) {
        
        return {};
      }
    },
    // 更新表单数据
    async updateFormData(taxFormConfig, identityConfig, identityInfo, identityConfig31) {
      
      // 8ben数据为空
      if (taxFormConfig && Object.keys(taxFormConfig).length <= 0) {
        await this.applyIdentityConfig(identityConfig, identityInfo, identityConfig31);
      } else {
        this.formData = taxFormConfig.w_ben_content;
        await this.convertAddressToEnglish();
      }
    },
    // 使用身份证中的字段信息
    async applyIdentityConfig(identityConfig, identityInfo, identityConfig31) {
      // 复制基础字段
      Object.keys(this.formData).forEach(key => {
        this.formData[key] = this.getConvertedText(identityInfo[key]) || '';
      });
      // 如果是中国大陆则地区使用3-1的数据
      if ( this.process_id == 1 ) {
        this.formData.identity_province_code = identityConfig31.province_code || ''
        this.formData.identity_province_name = identityConfig31.province_name || ''
        this.formData.identity_city_code = identityConfig31.city_code || ''
        this.formData.identity_city_name = identityConfig31.city_name || ''
        this.formData.identity_country_name = identityConfig31.country_name || ''
        this.formData.identity_country_code = identityConfig31.country_code || ''
        this.formData.identity_detail_address = this.getConvertedText(identityConfig31.detail_address || '')
        // 转换身份地址为英文
        if (this.formData.identity_province_code) {
          const { identity_province_code, identity_city_code, identity_country_code } = this.formData;
          const enAreaList = await this.$apis.getAddressLists({ type: 'en' });
          if (identity_province_code && enAreaList && enAreaList.province_list) {
            this.formData.identity_province_name = enAreaList.province_list[identity_province_code] || this.formData.identity_province_name;
          }
          if (identity_city_code && enAreaList && enAreaList.city_list) {
            this.formData.identity_city_name = enAreaList.city_list[identity_city_code] || this.formData.identity_city_name;
          }
          if (identity_country_code && enAreaList && enAreaList.county_list) {
            this.formData.identity_country_name = enAreaList.county_list[identity_country_code] || this.formData.identity_country_name;
          }
        }
      }
      let countryArea  = this.countryAddress.find(item => item.id == identityConfig.nationality_code);
      // 如果没有找到对应的国家地区信息，提供默认值或处理逻辑
      if (!countryArea) {
        countryArea = { name: identityConfig.nationality_name };     // 设置默认值
      }
      // key不一样，这里额外处理
      this.formData.tax_name = identityConfig.english_name || '';     // 纳税人姓名
      this.formData.contain_area = countryArea.name || '';            // 地区从国籍列表查出来
      // 使用 nationality_or_region_code 查找对应的英文名
      const nationalityCode = identityInfo.nationality_or_region_code || identityInfo.nationality_code;
      const nationalityArea = this.countryAddress.find(item => item.id == nationalityCode);
      this.formData.nationality_or_region_name = nationalityArea ? nationalityArea.name : (identityInfo.nationality_or_region_name || identityInfo.nationality_name || '');
      this.formData.nationality_or_region_code = identityInfo.nationality_or_region_code
      await this.convertAddressToEnglish();
    },
    // 大陆身份证才进行拼音转换
    getConvertedText(text) {
      const regex = /^[\u4e00-\u9fa5a-zA-Z0-9\s,.-]+$/;
      if (typeof text == 'string' && regex.test(text)) {
        return this.convertToPinyin(text);
      }
      return text;
    },
    // 繁体转简体（仅当前需要的字）
    traditionalToSimplified(text) {
      if (!text) return '';
      const traditionalMap = {
        '區': '区'
      };
      let result = text;
      Object.keys(traditionalMap).forEach(traditional => {
        const simplified = traditionalMap[traditional];
        result = result.replace(new RegExp(traditional, 'g'), simplified);
      });
      return result;
    },
    // 中文转拼音（仅处理西藏多音字）
    convertToPinyin(text) {
      if (!text) return '';
      const simplifiedText = this.traditionalToSimplified(text);
      // 处理"西藏"多音字问题
      if (simplifiedText.indexOf('西藏') >= 0) {
        const parts = simplifiedText.split('西藏');
        const result = [];
        for (let i = 0; i < parts.length; i++) {
          if (parts[i]) {
            const pinyinArray = pinyin(parts[i], { toneType: 'none', style: pinyin.STYLE_NORMAL, heteronym: false });
            result.push(pinyinArray.map(arr => arr[0]).join(' '));
          }
          if (i < parts.length - 1) {
            result.push('xi zang');
          }
        }
        return result.filter(item => item).join(' ');
      }
      const pinyinArray = pinyin(simplifiedText, { toneType: 'none', style: pinyin.STYLE_NORMAL, heteronym: false }); // 不带声调
      return pinyinArray.map(arr => arr[0]).join(' ');
    },
    // 获取国籍列表
    async getAreaList() {
      try {
        const result = await this.$apis.getAllCountryList({ language: 'en' });
        this.countryAddress = result;
      } catch (error) {
        
      }
    },
    // 获取省市区列表
    async getAddress() {
      try {
        const type = this.process_id == 1 ? 'zh' : 'en';
        const areaList = await this.$apis.getAddressLists({ type });
        this.areaList = areaList;
      } catch (error) {
        
      }
    },
    showAddressPopup() {
      this.showPopup = true;
    },
    inputFocus(id){
      this.inputFocusId = id;
    },
    inputBlur(){
      this.inputFocusId = null;
    },
    getFullAddress() {
      const { province_name, city_name, country_name } = this.formData;
      return [province_name, city_name, country_name]
        .filter(name => name)
        .join("，");
    },
    getIdentityFullAddress() {
      const { identity_province_name, identity_city_name, identity_country_name } = this.formData;
      return [identity_province_name, identity_city_name, identity_country_name]
        .filter(name => name)
        .join("，");
    },
    async onAddressTypeConfirm(arr) {
      const [province, city, country] = [0, 1, 2].map(index =>
        this.extractInfo(arr, index)
      );
      Object.assign(this.formData, {
        province_name: this.getConvertedText(province.name),
        province_code: province.code,
        city_name: this.getConvertedText(city.name),
        city_code: city.code,
        country_name: this.getConvertedText(country.name),
        country_code: country.code
      });
      await this.convertAddressToEnglish();
      this.showPopup = false;
    },
    extractInfo(arr, index) {
      const item = arr[index];
      return item
        ? { name: item.name, code: item.code }
        : { name: "", code: "" };
    },
    containsChinese(str) {
      const chineseRegex = /[\u4e00-\u9fa5]/; // 匹配中文字符的正则表达式
      return chineseRegex.test(str);
    },
    formatVal(e){
      return e.replace(/[\u4e00-\u9fa5]/g, '');
    },
    async handleNext() {
      this.showError = true;
      // 检查纳税人姓名和所属地区是否包含中文字符
      if (this.containsChinese(this.formData.tax_name)) {
        Toast(this.$t('w8benPage.nameInEnglish'));
        return;
      }
      if (this.containsChinese(this.formData.contain_area)) {
        Toast(this.$t('w8benPage.areaEnglish'));
        return;
      }
      // 检查详细地址是否包含中文字符
      if (this.containsChinese(this.formData.detail_address)) {
        Toast(this.$t('w8benPage.addrEnglish'));
        return;
      }
      // 其它地区的地址归属不能输入中文
      if ( this.process_id == 3 && this.containsChinese(this.formData.otherAffiliation)) {
        Toast(this.$t('w8benPage.areaEnglish'));
        return;
      }
      
      // 处理下一步逻辑
      if (this.isFormValid) {
        
        const loading = Toast.loading({
          duration: 0,
          forbidClick: true,
          loadingType: "spinner",
          message: this.$t("common.loading_text")
        });
        await this.reportData();
        let path = "/open-account/customerState";
        if(this.$route.query.change == 1){
          path = "/open-account/home";
        }
        this.$router
            .push(path)
            .finally(() => {
              loading.clear();
            });
      }
    },
    // 选中并关闭国籍弹窗
    checkCountry(e) {
      this.formData.contain_area = e.name;
      this.checkCountryNameDialog = false;
    },
    // 打开国籍弹窗
    checkCountryDialog() {
      if ( this.pageChange == 1 ) {
        this.checkCountryNameDialog = true;
      }
    },
    async convertAddressToEnglish() {
      if (!this.formData.province_code) {
        return;
      }
      const { province_code, city_code, country_code } = this.formData;
      const enAreaList = this.process_id == 1 ? await this.$apis.getAddressLists({ type: 'en' }) : this.areaList;
      if (province_code && enAreaList && enAreaList.province_list) {
        this.formData.province_name = enAreaList.province_list[province_code] || this.formData.province_name;
      }
      if (city_code && enAreaList && enAreaList.city_list) {
        this.formData.city_name = enAreaList.city_list[city_code] || this.formData.city_name;
      }
      if (country_code && enAreaList && enAreaList.county_list) {
        this.formData.country_name = enAreaList.county_list[country_code] || this.formData.country_name;
      }
    },
    async reportData() {
      await this.convertAddressToEnglish();
      const config_data = {
        w_ben_content:{
          ...this.formData
        }
      }
      await this.$apis.supplementSaveApi({ process_id: this.process_id, step_code: 10, step_order: 10, config_data });
    }
  },
  beforeDestroy() {
    // this.reportData();
  }
};
</script>

<style lang="less" scoped>
.w8ben-container {
  min-height: 100vh;
  background-color: white;
  padding: 124px 32px 200px;
  box-sizing: border-box;
}

.card-wrapper {
  .info-card {
    display: flex;
    flex-direction: column;
    padding: 20px 32px;
    box-sizing: border-box;
    position: relative;
    &:after{
      content: '';
      position: absolute;
      margin-top: -1px;
      top: -50%;
      left: -50%;
      width: 200%;
      height: 200%;
      border: 1px solid rgba(23, 22, 28, 0.25);
      transform: scale(0.5);
      border-radius: 20px;
    }
    .card-title {
      font-size: 24px;
      line-height: 24px;
      color: #747377;
      padding: 4px 0 20px;
    }
    ::v-deep .van-cell {
      z-index: 2;
      min-height: 0px;
      // font-size: 32px;
      // line-height: 32px;
      input{
        font-weight: 500;
        &::placeholder {
          font-size: 28px;
          color: #747377;
          font-weight: normal;
        }
        &:focus ~ .van-field__body{
          background: red;
        }
      }
      textarea {
        font-size: 32px;
        line-height: 35px;
        min-height: 70px;
        color: #17161c;
      }
    }
    .card-content {
      color: #17161C;
      position: relative;
      font-weight: 500;
      font-size: 28px;
      /deep/ .van-field__body {
        input {
          line-height: 28px;
        }
      }
      /deep/ .van-field__control {
        font-size: 28px;
        color: #17161C;
      }
      &.readonly {
        color: #B9B9B9;
      }

      .right-icon {
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        color: #999999;
      }
      /deep/ .van-cell {
        background: transparent;
        padding: 0;
      }
      &.other {
        .van-cell {
          min-height: auto;
        }
      }
    }
    &:not(:last-child) {
      margin-bottom: 24px;
    }
    &.editPage {
      .van-cell {
        padding: 0px !important;
        min-height: auto;
      }
    }
  }
  .error-message {
    color: #f56c6c;
    font-size: 24px;
    margin: -16px 0px 10px;
  }
}

.check-country {
  width: 100%;
  height: 100vh;
  border-radius: 0;
  z-index: 9999 !important;
  display: flex;
  flex-direction: column;
  .dialog-head {
    height: 100px;
    display: flex;
    padding: 0 100px;
    position: relative;
    .btn-back {
      position: absolute;
      left: 0;
      top: 0;
      height: 100px;
      width: 100px;
      background: url("../../../assets/images/arrow-right.png") no-repeat center;
      background-size: 48px 48px;
      transform: rotateY(180deg);
    }
    .dialog-title {
      flex: 1;
      text-align: center;
      font-size: 32px;
      color: #17161c;
      line-height: 100px;
    }
  }
  .input-box {
    padding: 0 32px;
    ::v-deep .van-cell {
      border-radius: 10px;
      background: #f7f8fa;
      min-height: 75px;
    }
  }
  .list {
    margin-top: 20px;
    flex: 1;
    position: relative;
    .list-main {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      overflow-y: scroll;
      .item {
        line-height: 80px;
        padding: 0 32px;
        border-bottom: 1px solid rgba(23, 22, 28, 0.1);
        font-size: 28px;
        color: #323233;
        display: flex;
        justify-content: space-between;
        align-items: center;
        &.cur {
          color: #ff9275;
        }
      }
    }
  }
}

.black-theme {
  .w8ben-container {
    background: #1B1C24 !important;
    .info-card {
      .card-content {
        color: white;
      }
      &:after{
        border-color: rgba(255,255,255,0.25);
      }
      /deep/ .van-field__control {
        color: white;
      }
      &.disabled {
        background: #14151d;
      }
    }
    .ipt-box{
      &.disabledBg {
        background: #14151D;
        /deep/ .van-cell {
          background: #14151D;
        }
        .icon-arrow{
          opacity: .4;
        }
      }
        &.focus{
          .ipt-main{
            &:after{
              border-color: rgba(255,255,255,0.25);
            }
          }
        }
        &.error{
          .ipt-main{
            &:after{
              border-color: #fd2626;
            }
          }
        }
        .ipt-main{
          &:after{
            border-color: rgba(255,255,255,0.25);
          }
          .label{
            color: #9D9D9F;
          }
          .icon-arrow{
            background: url("../../../assets/images/open-account/dark_icon.png") no-repeat;
            width: 32px;
            height: 32px;
            background-size: 100% 100%;
          }
          .val{
            color: #fff;
            ::v-deep{
              .van-cell__value input::placeholder {
                color: #9D9D9F !important;
              }
              textarea{
                color: #fff;
              }
            }
          }
        }
      }
  }
  .box {
    .title {
      color: white;
    }
  }
}

.box {
  .title {
      font-size: 32px;
      line-height: 32px;
      margin: 32px 0px;
      font-weight: 500;
  }
}

.ipt-box {
  margin-bottom: 24px;
  &.disabledBg {
    background: #F9FAFC;
    /deep/ .van-cell {
      background: #F9FAFC;
    }
    .val{
      color: #c8c9cc !important;
    }
  }
  &.focus{
    .ipt-main{
      &:after{
        border-color: #17161C;
      }
      ::v-deep .van-cell{
        input {
          &::placeholder {
            font-size: 0;
          }
        }
      }
    }
  }
  &.error{
    .ipt-main {
      &:after {
        border-color: #FD2626;
      }
    }
  }
  .ipt-main {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 32px;
    min-height: 56px;
    position: relative;
    &:after{
      content: '';
      position: absolute;
      margin-top: -1px;
      top: -50%;
      left: -50%;
      width: 200%;
      height: 200%;
      border: 1px solid rgba(23, 22, 28, 0.25);
      transform: scale(0.5);
      border-radius: 20px;
    }
    .val-box {
      position: relative;
      z-index: 3;
      flex: 1;
      display: flex;
      flex-direction: column;
      line-height: 1;
      font-size: 32px;
      @keyframes labelAni{
        0%{
          font-size: 28px;
        }
        100%{
          font-size: 24px;
        }
      }
      .label {
        color: #747377;
        padding: 4px 0 20px;
        font-size: 24px;
        transform: translate3d(0,0,0);
            animation: labelAni .2s .1s linear both;
        &.placeholder {
          padding: 12px 0 6px 0;
          font-size: 28px;
          animation: none;
        }
      }
      ::v-deep .van-cell {
        min-height: 0px;
        font-size: 32px;
        line-height: 32px;
        input{
          &::placeholder {
            font-size: 28px;
            color: #747377;
            font-weight: normal;
          }
          &:focus ~ .van-field__body{
            background: red;
          }
        }
        textarea {
          font-size: 32px;
          line-height: 35px;
          min-height: 70px;
          color: #17161c;
        }
      }
      .val {
        padding: 0;
        line-height: 36px;
        color: #17161c;
        font-weight: 500;
      }
    }
    .icon-arrow {
      width: 32px;
      height: 32px;
      background: url("../../../assets/images/arrow-down.png") no-repeat;
      background-size: 100% 100%;
    }
  }
  .error {
    display: none;
    margin-top: 12px;
    color: #fd2626;
    font-size: 24px;
    &.show{
      display: block;
    }
    &.right{
      text-align: right;
    }
  }
  &.error{
    .ipt-main{
      border-color: #fd2626;
    }
    .error{
      display: block;
    }
  }
}

.darkOrLight{
  width: 100%;
  height: 100vh;
  border-radius: 0;
  z-index: 9999 !important;
  display: flex;
  flex-direction: column;
  background: #1B1C24;
  .dialog-head {
    height: 100px;
    display: flex;
    padding: 0 100px;
    position: relative;
    .btn-back {
      position: absolute;
      left: 0;
      top: 0;
      height: 100px;
      width: 100px;
      background: url("../../../assets/images/open-account/open-back.png") no-repeat center;
      background-size: 48px 48px;
      transform: rotateY(0deg);
    }
    .dialog-title {
      flex: 1;
      text-align: center;
      font-size: 32px;
      color: #FFFFFF;
      line-height: 100px;
    }
  }
  .input-box {
    padding: 0 32px;
    ::v-deep .van-cell {
      border-radius: 10px;
      background: #f7f8fa;
      min-height: 75px;
    }
  }
  .list {
    margin-top: 20px;
    flex: 1;
    position: relative;
    .list-main {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      overflow-y: scroll;
      .item {
        line-height: 80px;
        padding: 0 32px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        font-size: 28px;
        color: #FFFFFF;
        display: flex;
        justify-content: space-between;
        align-items: center;
        &.cur {
          color: #ff9275;
        }
      }
    }
  }
}

.address-popup{
  border-radius: 32px 32px 0 0;
  ::v-deep .van-picker{
    //border-radius: 32px 32px 0 0;
    .van-picker__toolbar{
      padding-top: 32px;
    }
    .van-picker__cancel {
      font-size: 32px;
    }
    .van-picker__confirm {
      font-size: 32px;
    }
  }
}
</style>
